export const CLIENT_INTERACTION = 'CLIENT_INTERACTION';
export const PREVENT_USER_SELECT = 'PREVENT_USER_SELECT';
export const ALLOW_USER_SELECT = 'ALLOW_USER_SELECT';
